import * as React from "react";
import {
  Column,
  TableIDType,
} from "Components/Shared/PrimaryDataTable/PrimaryDataTable";
import { FilterUpIcon } from "Components/Shared/Icons/FilterUpIcon";
import { FilterDownIcon } from "Components/Shared/Icons/FilterDownIcon";

type Props<T> = {
  column: Column<T>;
};

export type OrderByProps<T> = {
  setOrderBy: (value: TableIDType<T>) => void;
  orderBy: TableIDType<T>;
  setDesc: (value: boolean) => void;
  desc: boolean;
};

export const PrimaryDataTableOrderBy = <T extends object>(props: Props<T>) => {
  const { column } = props;

  const onClickOrderBy = () => {
    if (column.orderBy) {
      if (column.orderBy.orderBy === column.id) {
        column.orderBy.setDesc(!column.orderBy.desc);
      }
      column.orderBy.setOrderBy(column.id);
    }
  };

  const setActiveCssClass = () =>
    column.orderBy?.orderBy === column.id ? "active" : "";

  return (
    <>
      {column.orderBy && (
        <div
          onClick={() => onClickOrderBy()}
          className={`order-by-wrapper ${setActiveCssClass()}`}
        >
          <div className={"order-by-icon-wrapper"}>
            {column.orderBy.desc ? <FilterUpIcon /> : <FilterDownIcon />}
          </div>
        </div>
      )}
    </>
  );
};
